import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-product-promotion',
  standalone: true,
  imports: [],
  templateUrl: './product-promotion.component.html',
  styleUrl: './product-promotion.component.scss'
})
export class ProductPromotionComponent {
  @Input() promotion: any = [];
  constructor() {}
}
